import React from 'react'
import { FORMAT } from '../../config/const'
import { customDateTimeFormat } from '../../helper/common'
export default function ItemCs(props) {
  const {info, cate} = props
  return (
    <div className='cs_content'>
      <div className='fs-12 f-m color-9e9e9e text-right'>{customDateTimeFormat(info.cs_createdat)}</div>
      <div className='d-flex align-item-center mt-6'>
        <div className='cs-category fs-12 f-sb d-flex align-items-center'>{cate[info.cs_cate - 1]}</div>
        <div className='d-center fs-20 sm-fs-16 f-sb ml-12'>{info.cs_title}</div>
      </div>
      <div className='fs-14 color-3a3335 mt-10'>{info.cs_note}</div>
      {info.cs_ans_id > 0 && <div className='cs-answer-area mt-20 fs-14'>{info.cs_answer}</div>}
    </div>
  )
}

